import RequestStatus from "types/general/requests/RequestStatus";
import { createSlice } from "@reduxjs/toolkit";
import { GenericDataState, createSetFetchDataPendingReducer, createSetFetchDataSuccesReducer, createSetFetchDataErrorReducer, createResetRequestStatusReducer } from "../generic/GenericDataReducers";
import { defaultDataTablePageSize } from "functions/tables/TableFunctions";
import IOrder from "types/backend_models/orders/IOrder";
import { ITableData } from "types/backend_models/shared/ITableData";

// NON GENERIC
/* DEFAULT STATE & TYPES */
// interface IOrdersDataState extends IDefaultRequestProps {
// 	orders: IOrdersResult
// }

// const defaultState: IOrdersDataState = {
// 	requestStatus: RequestStatus.idle,
// 	orders: {
// 		results: [],
// 		currentPage: 0,
// 		pageCount: 0,
// 		pageSize: 0,
// 		rowCount: 0
// 	},
// 	error: null
// }

// /* REDUCERS */
// const setFetchOrdersPendingReducer: CaseReducer<IOrdersDataState> = (state: IOrdersDataState) => {
// 	state.requestStatus = RequestStatus.pending;
// 	state.error = null;
// };
// const setFetchOrdersSuccesReducer: CaseReducer<IOrdersDataState, PayloadAction<{ orders: IOrdersResult }>> = (state: IOrdersDataState, action) => {
// 	state.requestStatus = RequestStatus.succes;
// 	state.orders = action.payload.orders;
// };
// const setFetchOrdersErrorReducer: CaseReducer<IOrdersDataState, PayloadAction<{ error: string }>> = (state: IOrdersDataState, action) => {
// 	state.requestStatus = RequestStatus.error;
// 	state.error = action.payload.error;
// };

/* SLICE */
// const orderSlice = createSlice({
// 	name: "order",
// 	initialState: defaultState,
// 	reducers: {
// 		setFetchOrdersPending: setFetchOrdersPendingReducer,
// 		setFetchOrdersSucces: setFetchOrdersSuccesReducer,
// 		setFetchOrdersError: setFetchOrdersErrorReducer
// 	}
// });

// GENERIC
const initialState: GenericDataState<ITableData<IOrder[]>> = {
	requestStatus: RequestStatus.idle,
	data: {
		results: [],
		currentPage: 1,
		pageCount: 0,
		pageSize: defaultDataTablePageSize,
		rowCount: 0
	},
	error: null
}

const orderSlice = createSlice({
	name: "order",
	initialState: initialState,
	reducers: {
		setFetchOrdersPending: createSetFetchDataPendingReducer(),
		setFetchOrdersSucces: createSetFetchDataSuccesReducer(),
		setFetchOrdersError: createSetFetchDataErrorReducer(),
		resetOrdersFetchStatus: createResetRequestStatusReducer(),
	}
});

export const {
	setFetchOrdersPending,
	setFetchOrdersSucces,
	setFetchOrdersError,
	resetOrdersFetchStatus
} = orderSlice.actions;

export default orderSlice.reducer;